import { css } from "@emotion/react";

export const tableWrapper = css`
  width: 100%;
  overflow: hidden;
  border: 1px solid #eef0f5;
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.04);
  margin-top: 18px;
`;

export const table = css`
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
`;

export const tableHeader = css``;

export const tableBody = css``;

export const tableHeaderRow = css``;

export const tableBodyRow = css`
  transition: background 0.18s ease;

  &:hover {
    background: #f8fbff;
  }

  &:not(:last-of-type) td {
    border-bottom: 1px solid #f1f5f9;
  }
`;

export const tableHeaderCell = css`
  background-color: #f8fafc;
  border-bottom: 1px solid #eef0f5;
  padding: 16px 18px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: 12px;
  text-align: left;
  line-height: 14px;
  color: #475569;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;

export const tableBodyCell = css`
  padding: 18px;
  text-align: left;
  font-size: 13px;
  line-height: 18px;
  color: #0f172a;
  vertical-align: middle;
`;

export const actions = css`
  margin-top: 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const actionsRigth = css`
  margin-top: 10px;
  display: flex;
  justify-content: end;
  align-items: center;

  .button {
    margin-left: 10px;
  }
`;

export const left = css`
  display: flex;
  margin-right: 10px;

  & button {
    width: 86px;
  }
`;

export const filter = css`
  width: 168px;
  margin-right: 10px;
`;

export const search = css`
  max-width: 350px;
`;

export const sizeX = css`
  width: 50px;
`;

export const imageCellD = css`
  height: 25px;
  margin: 0 auto;
  display: flex;
`;

export const icon = css`
  cursor: pointer;
`;

export const statusBadge = (isActive: boolean) => css`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  color: ${isActive ? "#047857" : "#991b1b"};
  background: ${isActive ? "#ecfdf5" : "#fef2f2"};

  &::before {
    content: "";
    width: 7px;
    height: 7px;
    border-radius: 999px;
    background: ${isActive ? "#10b981" : "#ef4444"};
  }
`;

export const actionButton = css`
  border: 0;
  border-radius: 12px;
  background: #34189a;
  color: #ffffff;
  padding: 10px 18px;
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;
  transition: all 0.18s ease;

  &:hover {
    background: #25106f;
    transform: translateY(-1px);
  }
`;

export const emptyState = css`
  padding: 32px;
  text-align: center;
  color: #64748b;
  font-size: 14px;
`;